import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { NavBar } from '../components/NavBar'
import { useProfile } from '../hooks/useProfile'

export function ProfilePage() {
  const { user } = useAuth()
  const { profile, loading, error } = useProfile(user?.id)

  const displayName = profile?.display_name || profile?.username || 'Your profile'

  return (
    <div className="min-h-screen bg-stone-900 text-stone-100">
      <NavBar />
      <div className="px-6 py-10">
      <div className="mx-auto max-w-2xl">
        <h1 className="mb-8 font-serif text-3xl font-semibold tracking-tight">Profile</h1>

        {loading ? (
          <div className="space-y-4">
            <div className="flex items-center gap-4">
              <div className="h-16 w-16 rounded-full bg-stone-800" />
              <div className="space-y-2">
                <div className="h-5 w-40 rounded bg-stone-800" />
                <div className="h-4 w-28 rounded bg-stone-800" />
              </div>
            </div>
          </div>
        ) : error ? (
          <p className="text-sm text-red-400">Failed to load profile: {error}</p>
        ) : (
          <div className="space-y-6">
            <div className="flex items-center gap-4">
              {profile?.avatar_url ? (
                <img
                  src={profile.avatar_url}
                  alt={displayName}
                  className="h-16 w-16 rounded-full object-cover"
                />
              ) : (
                <div
                  data-testid="avatar-placeholder"
                  className="flex h-16 w-16 items-center justify-center rounded-full bg-stone-700 font-serif text-2xl text-stone-400"
                >
                  {(profile?.display_name || profile?.username || '?')[0].toUpperCase()}
                </div>
              )}
              <div>
                <p
                  data-testid="display-name"
                  className="font-serif text-xl font-semibold text-stone-100"
                >
                  {displayName}
                </p>
                {profile?.username && (
                  <p data-testid="username" className="text-sm text-stone-500">
                    @{profile.username}
                  </p>
                )}
              </div>
            </div>

            {profile?.bio && (
              <p className="text-sm leading-relaxed text-stone-300">{profile.bio}</p>
            )}

            {profile?.location && (
              <p className="text-sm text-stone-500">{profile.location}</p>
            )}

            <div className="border-t border-stone-800 pt-6">
              <Link
                to="/diary"
                className="text-sm text-stone-400 transition-colors hover:text-amber-400"
              >
                View my diary →
              </Link>
            </div>
          </div>
        )}
      </div>
      </div>
    </div>
  )
}
